import { createSelector } from 'reselect';
import { createMaybeSelector, selectWithLoadState } from '@ally/data-selectors';
export var getDomainData = function (_a) {
    var _b;
    var transferAccounts = _a.transferAccounts;
    return (_b = transferAccounts === null || transferAccounts === void 0 ? void 0 : transferAccounts.data) !== null && _b !== void 0 ? _b : null;
};
export var getAllTransferAccounts = createMaybeSelector(getDomainData, function (data) { return data.accounts; });
export var getIsNewCustomer = createMaybeSelector(getDomainData, function (data) { return data.isNewCustomer; });
/**
 * These selectors return the loading state of the data
 * and a timestamp of when the data was last fetched.
 */
export var getDataStatus = function (_a) {
    var transferAccounts = _a.transferAccounts;
    return transferAccounts.status;
};
export var getDataLoadState = createSelector(getDataStatus, function (status) { return status.loadState; });
export var getDataTimeStamp = createSelector(getDataStatus, function (status) { return status.timeStamp; });
/**
 * This selector returns the error message state (if any)
 */
export var getError = function (_a) {
    var transferAccounts = _a.transferAccounts;
    return transferAccounts.error;
};
/**
 * `withTransferAccountsLoadState` returns an object that will render its contents based on load state
 */
export var withTransferAccountsLoadState = selectWithLoadState(getDataLoadState, getError);
//# sourceMappingURL=selectors.js.map